const getPaddingLeft = ({ maxLength, resizeY }) => {
  if (maxLength && resizeY) return 'pr-[70px]';
  if (maxLength) return 'pr-[60px]';
  if (resizeY) return 'pr-[20px]';
  return '';
};

export default getPaddingLeft;
